export default {
	text: "{changedBy} renamed this goal from <span class='text-strike'>{from}</span> to {to}",
};
